import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import { getAccessToken } from 'helpers/tokenManager';
import { useCustomTranslation } from 'helpers/translationHelper';
import React, { useEffect, useState } from 'react';
import imgNotFound from 'static/images/image_not_found.png';

interface Props {
  url: string;
  requireToken?: boolean;
  alt?: string;
  title?: string;
  className?: string;
  placeholder?: string;
  width?: number | string;
}

interface ImageConfig {
  src: string;
  alt?: string;
  title?: string;
  width?: number | string;
}

const ImageComponent: React.FC<Props> = (props): React.ReactElement => {
  const { t } = useCustomTranslation();

  const urlWithToken = props.requireToken
    ? `${props.url}?access_token=${getAccessToken()}`
    : props.url;

  const [imgConfig, setImgConfig] = useState<ImageConfig>({
    src: urlWithToken,
    alt: props.alt,
    title: props.title,
    width: props.width
  });

  useEffect(() => {
    setImgConfig({
      src: urlWithToken,
      alt: props.alt,
      title: props.title,
      width: props.width
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlWithToken]);

  const onError = () =>
    setImgConfig({
      src: imgNotFound,
      alt: t('common.imageNotFound'),
      title: t('common.imageNotFound'),
      width: '25%'
    });

  return (
    <img
      src={imgConfig.src}
      className={props.className || ''}
      alt={imgConfig.alt}
      title={imgConfig.title}
      width={imgConfig.width}
      onLoad={() => <LoadingIndicator />}
      onError={onError}
    />
  );
};

export default ImageComponent;
